import React, { Component } from 'react'
import Radium from 'radium'
import { Button } from 'reactstrap'

import logo from '../images/1C_primary_RGB_KO.png'

class Header extends Component {

  render () {
    return (
      <header style={headerStyle}>
        <img style={imageStyle} src={logo} alt="Logo" />
        { this.props.isLoggedIn && (
          <Button color='primary' onClick={this.props.handleLogout} >Log Out</Button>
        )}
      </header>
    )
  }
}

const headerStyle = {
  background: '#602d89',
  color: '#fff',
  padding: '10px',
  display: 'flex',
  justifyContent: 'space-between',
  '@media (max-width: 420px)': {
    textAlign: 'center',
  },
  '@media (min-width: 421px)': {
    textAlign: 'left',
  },
}

const imageStyle = {
  width: 'auto',
  '@media (max-width: 420px)': {
    maxHeight: '60px',
  },
  '@media (min-width: 421px)': {
    maxHeight: '70px',
  },
}

export default Radium(Header)
